import { AI_AGENTS_EVENTS } from '../../services/events';
import { AgentContextComponent, AgentType } from '@server/ai';
import { sendBiEvent } from '../../services/bi';
import { useCallback } from 'react';
import useAiAgents from './useAiAgents';
import useAgentsChats from './useAgentsChats';
import useAgentsHome from './useAgentsHome';

const useCreateAgent = (onFinishCb?: () => void) => {
  const { setAgentClickHandler } = useAgentsChats();
  const { createAgent } = useAiAgents();
  const { openAgentsPanel } = useAgentsHome();

  return useCallback(
    async ({
      type,
      name,
      selectedContext,
      instructions,
      shouldOpenCanvasPanel,
      bestPracticeIds,
    }: {
      type: AgentType;
      name: string;
      selectedContext: AgentContextComponent;
      shouldOpenCanvasPanel?: boolean;
      instructions?: string;
      bestPracticeIds?: string[];
    }) => {
      if (selectedContext) {
        sendBiEvent({ name: AI_AGENTS_EVENTS.createAgent });
        const newAgent = await createAgent({
          name,
          contextComponents: selectedContext,
          type,
          instructions,
          bestPracticeIds,
        });
        if (!newAgent) {
          return;
        }

        setAgentClickHandler({ agent: newAgent });

        if (shouldOpenCanvasPanel) {
          openAgentsPanel();
        }
        onFinishCb?.();
      }
    },
    [createAgent, setAgentClickHandler, onFinishCb, openAgentsPanel],
  );
};

export default useCreateAgent;
